/**
 * TrackString.js
 * Created on 2-dec-2015
 * 
 * All strings used for Analytics.
 * A lot of the strings are game specific.
 * 
 * @author Reinier Feijen for Ranj
 **/

const TrackString = {
	//GENERAL:
	DEVELOPMENT: "DEVELOPMENT",
	TEST: "TEST",
	ACCEPTANCE: "ACCEPTANCE",
	PRODUCTION: "PRODUCTION",
	
	SESSION: "SESSION",
	START: "START",
	END: "END",
	
	//NGT SPECIFIC:
	GAME: "GAME",
	SCENARIO: "SCENARIO",
	DIALOG: "DIALOG",
	CHOSEN: "CHOSEN",
	QUIZ: "QUIZ",
	CORRECT: "CORRECT",
	INCORRECT: "INCORRECT",
	AVAILABLE: "AVAILABLE",
	CONTENT: "CONTENT",
	STARTED: "STARTED",
	ENDED: "ENDED",
	
	//GAME SPECIFIC, change to project needs
	BROWSER: "BROWSER",
	LANGUAGE: "LANGUAGE",
	SCORE: "SCORE",
	FINAL: "FINAL",
	TOTAL: "TOTAL",
	CATEGORY: "CATEGORY",
	USERINTERACTION: "USERINTERACTION",

	
	//	Error messages:
	SUBMIT_FAILED: "SUBMIT_FAILED",
};

export default TrackString;